<template>
  <v-app app light :class="{
    'orange darken-3': $router.currentRoute.name === 'login'
      || $router.currentRoute.name === 'register'
  }">
    <notification></notification>
    <loading v-show="loading" :hold="loading"></loading>
    <free-notification></free-notification>
    <router-view></router-view>
  </v-app>
</template>
<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import Notification from './views/Components/Notification/Notification.vue';
import FreeNotification from './views/Components/Notification/FreeNotification.vue';
import Loading from './views/Components/Loading.vue';

export default {
  name: 'GodApp',
  components: {
    Loading,
    FreeNotification,
    Notification,
  },
  computed: {
    ...mapGetters(['loading']),
  },
  data: () => ({ n: 1 }),
  watch: {
    $route() {
      document.title = this.$store.state.user.site
        ? `${this.$store.state.user.site.toUpperCase()} - Sms Gönderim Paneli`
        : 'Sms Gönderim Paneli';
    },
  },
  beforeMount() {
    const expiry = localStorage.getItem('expiresAt');
    if (expiry !== null) {
      const expiryDate = new Date(expiry);
      if (Date.compareGreater(
        new Date((new Date())), expiryDate,
      )) {
        this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login').catch(() => { });
          });
      }
    }
    Vue.axios.interceptors.response.use(
      response => Promise.resolve(response),
      (error) => {
        if (!error.status) {
          if (this.$route.name !== 'connection') {
            this.$router.push({ name: 'connection', params: { latest: this.$route } })
              .then(() => { this.n = 1; });
          }

          return Promise.reject('Bir şeyler ters gitti');
        }
        if (!error.response && this.n <= 2) {
          this.n += 1;
          Vue.axios.request(error.config);
        }

        if (this.n === 2) {
          if (this.$route.name !== 'connection') {
            this.$router.push({ name: 'connection', params: { latest: this.$route } })
              .then(() => { this.n = 1; });
          }
        }
      },
    );


    Vue.axios.interceptors.response.use(success => new Promise((resolve, reject) => {
      if (success !== undefined) {
        if (success.data && (success.data.code === 401)) {
          return this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login').catch(() => { });
            });
        }

        if (success.data && (success.data.code === 403)) {
          return this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login').catch(() => { });
            });
        }

        // eslint-disable-next-line no-prototype-builtins
        if (success.data.hasOwnProperty('code')) {
          if (success.data.code !== 200) {
            reject(success.data.description);
          } else {
            resolve(success);
          }
        } else {
          resolve(success);
        }
      }
    }));
  },
};
</script>

<style lang="scss">
body * {
  font-family: "Inter", sans-serif !important;

  &.material-icons {
    font-family: 'Material Icons' !important;
  }
}

.v-input__slot {
  border: 2px solid #CACACA;
  border-radius: 5px;
  padding: 8px 8px;
}

.theme--light.v-label {
  left: 0px;
  right: auto;
  background: #FFF;
  padding: 0 8px;
  position: absolute;
}

.theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  border: 0;
}


.v-app-bar--fixed {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.04) !important;
}

.active-nav-custom {
  background-color: rgba(255, 171, 0, 1) !important;
}

.customer-whatsapp-credit {
  background-image: radial-gradient(814px at 19.1% 53.8%, #36dd79 32.5%, #32cd32 100.2%);
}
.customer-other-project {
  background-image: radial-gradient(814px at 19.1% 53.8%, #8c9f94 32.5%, #32cd32 100.2%);
}

.active-nav-custom>.v-list-item__title,
.active-nav-custom>.v-list-item__icon>i {
  color: #000;
}

.flex.xs6>.v-input>.v-input__control>.v-input__slot,
.flex.xs6>.v-input>.v-input__control>.v-input__slot>.v-text-field__slot>label {
  border: none;
  background: transparent;
}

.v-list-group .v-list-item {
  min-height: 44px !important;
  margin-bottom: 4px !important;
}

.eft-btn {
  background-color: #FC0 !important;
}

.credit-btn {
  border: 1px solid;
  border-color: #ff4522 !important;
}
/*.v-alert__content {*/
/*  overflow: auto !important;*/
/*}*/
</style>
